import { render, staticRenderFns } from "./InvestmentsIad.vue?vue&type=template&id=5e2ec3f5&scoped=true"
import script from "./InvestmentsIad.vue?vue&type=script&lang=js"
export * from "./InvestmentsIad.vue?vue&type=script&lang=js"
import style0 from "./InvestmentsIad.vue?vue&type=style&index=0&id=5e2ec3f5&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e2ec3f5",
  null
  
)

export default component.exports